import { Logger as u, request as n, StorageService as p } from "@nextgen-web-framework/core";
import { getMyShopReqObj as b, createShopReqObj as o, updateShopReqObj as i, uploadShopImageReqObj as I } from "../config/myshopApiEndPoints.js";
import m from "../../logObject.js";
import { VersionId as h, ShopId as S } from "../config/myshopApiConstants.js";
import { ApiProjections as w } from "../../types/enums/myshopConstantsEnum.js";
const j = {
  async getMyShop({ projections: t = w.ALL, shopCodeUrl: e = void 0 }, c) {
    const r = u.getInstance(m("myshopApi.getMyShop"));
    try {
      const a = { ...b };
      a.url = a.url.replace(h, "v1"), a.params = {
        projections: t
      }, e && e !== "" && (a.params = { shopCode: e, ...a.params }), c != null && c.headers && (a.headers = c == null ? void 0 : c.headers), c != null && c.baseURL && (a.url = `${c.baseURL}${a.url}`);
      const s = await n(a);
      if (Object.keys(s).includes("myshops")) {
        const l = s, { myshops: d } = l;
        if (Array.isArray(d) && d.length > 0)
          return d[0];
      }
      return s;
    } catch (a) {
      throw r.error("myshopApi.getMyShop", a), a;
    }
  },
  async createMyShop({ payload: t }, e) {
    const c = u.getInstance(m("myshopApi.createMyShop"));
    try {
      const r = { ...o };
      r.url = r.url.replace(h, "v1");
      const a = await g(t);
      return r.body = a, e != null && e.headers && (r.headers = e == null ? void 0 : e.headers), e != null && e.baseURL && (r.url = `${e.baseURL}${r.url}`), await n(r);
    } catch (r) {
      throw c.error("myshopApi.createMyShop", r), r;
    }
  },
  async updateMyShop({ payload: t }, e) {
    const c = u.getInstance(m("myshopApi.updateMyShop"));
    try {
      const r = { ...i }, a = p.getLocalStorage().retrieve("ShopId"), s = await g(t, a);
      return r.url = r.url.replace(h, "v1"), r.url = r.url.replace(S, a), r.body = s, e != null && e.headers && (r.headers = e == null ? void 0 : e.headers), e != null && e.baseURL && (r.url = `${e.baseURL}${r.url}`), await n(r);
    } catch (r) {
      throw c.error("myshopApi.updateMyShop", r), r;
    }
  },
  async uploadMyShopImage({ payload: t }, e, c) {
    const r = u.getInstance(m("myshopApi.uploadMyShopImage"));
    try {
      const a = { ...I };
      return a.url = a.url.replace(h, "v1"), a.body = t, c != null && c.headers && (a.headers = c == null ? void 0 : c.headers), c != null && c.baseURL && (a.url = `${c.baseURL}${a.url}`), e && e !== "" && (a.params = { inputShopId: e }), await n(a, {
        skipDefaultContentType: !0
      });
    } catch (a) {
      throw r.error("myshopApi.uploadMyShopImage", a), a;
    }
  }
};
async function g(t, e) {
  const c = u.getInstance(m("myshopApi.processPayloadBody"));
  try {
    const r = t, a = f(r, "profileImageData", "profile"), s = f(r, "bannerImageData", "banner"), l = [];
    return y(l, a, e), y(l, s, e), l.length > 0 && await A(l, r), r;
  } catch (r) {
    throw c.error("myshopApi.processPayloadBody", r), r;
  }
}
function y(t, e, c) {
  e && e.get("imageData") && t.push(j.uploadMyShopImage({ payload: e }, c));
}
async function A(t, e) {
  const c = u.getInstance(m("myshopApi.processUploadPromises"));
  try {
    const r = await Promise.allSettled(t);
    if (r.some((a) => a.status === "rejected"))
      throw new Error("error on upload image");
    r.forEach((a) => {
      if (a.status === "fulfilled") {
        const s = a.value;
        D(s, e);
      }
    });
  } catch (r) {
    throw c.error("myshopApi.processUploadPromises", r), r;
  }
}
function D(t, e) {
  var c, r;
  if (Object.keys(t).includes("bannerId")) {
    const a = t;
    (c = a.bannerId) != null && c.includes("banner") && (e.bannerImageData = void 0, e.bannerInfo = t), (r = a.bannerId) != null && r.includes("profile") && (e.profileImageData = void 0, e.profilePicture = {
      imageId: a.bannerId,
      imageUrl: a.bannerUrl,
      mime: a.mime
    });
  }
  Object.keys(t).includes("imageId") && (e.profileImageData = void 0, e.profilePicture = t);
}
function f(t, e, c) {
  let r = new FormData();
  if (["bannerImageData", "profileImageData"].includes(e) && t[e]) {
    const a = new FormData(), s = t[e], l = new Blob([s], { type: "image/jpeg" });
    return a.append("imageData", l, e === "bannerImageData" ? "banner.jpg" : "profile.jpg"), a.append("imageType", c), r = a, r;
  }
  return r;
}
export {
  y as addUploadPromise,
  j as default,
  f as getFormImage,
  j as myshopApi,
  g as processPayloadBody,
  A as processUploadPromises
};
//# sourceMappingURL=myshopApi.js.map
